module.exports = __webpack_public_path__ + "static/media/sheet.83fee667.svg";